import React from 'react';
import { Helmet } from 'react-helmet';

const Policy = () => {
  const styles = {
    
    sectionHeader: {
      color: 'var(--darkpurple)',
      fontSize: '1.7rem',
      marginBottom: '10px',
      marginTop: '20px',
    },
    paragraph: {
      fontSize: '1rem',
      color: '#555',
      lineHeight: '1.6',
      marginBottom: '10px',
    },
    list: {
      listStyleType: 'circle',
      paddingLeft: '20px',
      marginBottom: '10px',
    },
    listItem: {
      marginBottom: '8px',
    
    },
  };

  return (
    <>

<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 |Om Sai PG | Privacy & Policy | PG for Working Professionals Pune | Luxury PG in Kharadi | Paying Guest Near Kharadi IT Park Pune| PG Near Kharadi Eon IT Park  
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG for Working Professionals Pune,Luxury PG in Kharadi,Paying Guest Near Kharadi IT Park Pune, PG Near Kharadi Eon IT Park"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

    <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img2">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Privacy & Policy</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Privacy & Policy</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li>Privacy & Policy</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div className='container'>
      <h2 style={styles.header} className='text-purple pb-2'>Privacy Policy for Om Sai PG</h2>

      <p style={styles.paragraph}>
        At Om Sai PG, we take your privacy seriously. This Privacy Policy outlines the information we collect from you, how we use it, and how we protect it. By using our services, you agree to the collection and use of information in accordance with this policy.
      </p>

      <h3 style={styles.sectionHeader}>Information Collection</h3>
      <p style={styles.paragraph}>
        We collect the following types of information to provide and improve our services:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Personal Information: Name, contact details, and any other information provided during the booking process.</li>
        <li style={styles.listItem}>Usage Data: Information on how you use our website and services.</li>
        <li style={styles.listItem}>Payment Information: Payment details for booking and renting our PG rooms.</li>
      </ul>

      <h3 style={styles.sectionHeader}>How We Use Your Information</h3>
      <p style={styles.paragraph}>
        The information we collect is used for the following purposes:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>To process your bookings and reservations.</li>
        <li style={styles.listItem}>To improve our website, services, and customer support.</li>
        <li style={styles.listItem}>To communicate with you regarding your booking, updates, and promotional offers.</li>
        <li style={styles.listItem}>To manage and resolve any issues or disputes related to the services provided.</li>
      </ul>

      <h3 style={styles.sectionHeader}>Data Security</h3>
      <p style={styles.paragraph}>
        We are committed to protecting your personal data. We use commercially acceptable means to safeguard the information you provide, but please be aware that no method of transmission over the internet is 100% secure. Therefore, we cannot guarantee absolute security.
      </p>

      <h3 style={styles.sectionHeader}>Cookies</h3>
      <p style={styles.paragraph}>
        We use cookies to enhance your experience on our website. Cookies are small files stored on your device that help us remember your preferences and provide a better user experience. You can choose to disable cookies through your browser settings, but this may affect some website functionality.
      </p>

      <h3 style={styles.sectionHeader}>Sharing Your Information</h3>
      <p style={styles.paragraph}>
        We do not sell or rent your personal data to third parties. However, we may share your information with:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Third-party service providers who assist in booking, payments, and other services.</li>
        <li style={styles.listItem}>Authorities or legal entities in cases where disclosure is required by law.</li>
      </ul>

      <h3 style={styles.sectionHeader}>Your Rights</h3>
      <p style={styles.paragraph}>
        You have the right to:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Access the personal data we hold about you.</li>
        <li style={styles.listItem}>Request corrections to any inaccurate or incomplete data.</li>
        <li style={styles.listItem}>Request the deletion of your personal data under certain circumstances.</li>
      </ul>

      <h3 style={styles.sectionHeader}>Changes to This Privacy Policy</h3>
      <p style={styles.paragraph}>
        We reserve the right to update our Privacy Policy from time to time. Any changes will be posted on this page, and the revised policy will be effective immediately upon posting.
      </p>


      <div className='contact-section'>
      <h3 style={styles.sectionHeader} className='text-white' >Contact Us</h3>
      <p style={styles.paragraph} className='text-white'>
        If you have any questions or concerns about our Privacy Policy, please contact us at:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem} className='text-white'>Phone: 9763888448</li>
        <li style={styles.listItem} className='text-white'>Phone: 9922248255</li>
      </ul>
      </div>
    </div>
    </>
  );
};

export default Policy;
